module.exports = __webpack_public_path__ + "img/system-messages.c0bde0ad.svg";